(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    /*
   * Workaround for Horizon overflow-list #waitForStyles() race condition.
   * If the stylesheet's load event fires between the styles.sheet null-check
   * and the addEventListener call, the promise never resolves and #initialize()
   * never runs. This detects stalled overflow-lists and re-triggers connectedCallback(),
   * which is safe because:
   *   - DeclarativeShadowElement.connectedCallback() guards with if (!this.shadowRoot)
   *   - #waitForStyles() resolves immediately when styles.sheet is truthy (cached)
   *   - #initialize() sets up IntersectionObserver → fires immediately → #reflowItems()
   */
  function fixStalledOverflowLists() {
    document.querySelectorAll('.product-recommendations--standard-pdp overflow-list').forEach(function(ol) {
      if (!ol.isConnected || !ol.shadowRoot) return;
      if (ol.style.getPropertyValue('--overflow-count')) return;

      var link = ol.shadowRoot.querySelector('link[rel="stylesheet"]');
      if (link && link.sheet) {
        ol.connectedCallback();
      }
    });
  }

  setTimeout(fixStalledOverflowLists, 3000);
  setTimeout(fixStalledOverflowLists, 6000);
  } catch(e) { console.error(e); }
})();

})();
